import { gql } from '@apollo/client';

export const DELETE_TEMPLATE_MUTATION = gql`
  mutation RemoveTemplate($id: Int!) {
    removeTemplate(id: $id) {
      id
    }
  }
`;